<template>
  <v-flex class="py-3 px-2" xs12 sm11 lg10>
    <v-card class="elevation-2">
      <transition name="fade" mode="out-in" appear>
        <div v-if="loading" class="py-5 text-xs-center"><div class="my-5 py-5"><div class="my-5 py-5">
          <v-progress-circular color="accent" indeterminate></v-progress-circular>
        </div></div></div>
        <router-view v-else></router-view>
      </transition>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  data: () => ({
    loading: true
  }),
  mounted () {
    this.load()
  },
  methods: {
    load () {
      let appMsg = {
        type: 'error',
        msg: ''
      }
      if (this.$store.getters.user) {
        if (this.$store.getters.user.type.toLowerCase() === 'admin') {
          let contentLoaded = this.$store.getters.contentLoaded && this.$store.getters.sectionsLoaded && this.$store.getters.tasksLoaded
          let questionsLoaded = this.$store.getters.questionsLoaded
          let progressModuleLoaded = this.$store.getters.progressLoaded && this.$store.getters.taskProgressLoaded
          if (contentLoaded && progressModuleLoaded && questionsLoaded) this.loading = false
          else {
            this.$store.dispatch('loadQuestions').then(() => {
              this.$store.dispatch('loadContent').then(() => {
                this.$store.dispatch('loadSections').then(() => {
                  this.$store.dispatch('loadTasks').then(() => {
                    this.$store.dispatch('loadProgress').then(() => {
                      this.$store.dispatch('loadTaskProgress', this.$store.getters.user.uid).then(() => {
                        this.loading = false
                      })
                    })
                  })
                })
              })
            })
          }
        } else {
          appMsg.msg = 'You are not allowed to view that page'
          this.$store.dispatch('showAppMsg', appMsg)
          this.$router.push('/')
        }
      } else {
        appMsg.msg = 'Please sign in'
        this.$store.dispatch('showAppMsg', appMsg)
        this.$router.push('/sign-in')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/progress/Progress.vue